module.exports = __webpack_public_path__ + "img/icon_fp_blog.10ad1332.svg";